import { createContext, useContext } from 'react';
var RadioGroupContext = createContext({});
RadioGroupContext.displayName = 'RadioGroup';
export var RadioGroupProvider = RadioGroupContext.Provider;
export var useRadioGroup = function () {
    return useContext(RadioGroupContext);
};
